<script setup lang="ts">
  import { IFetchParams } from "@/composables/useFetchWithPagination"
  import { ISearchCmsData } from "@/view-models/search.model"
  import LoadMoreButton from "@/components/LoadMoreButton.vue"
  import SearchBar from "@/views/SearchOverview/components/SearchBar.vue"
  import SearchItem from "@/views/SearchOverview/components/SearchItem.vue"

  const cmsData = CMSDataProvider.get<ISearchCmsData>(CMS_DATA_ID.SEARCH)

  const search = async (params: IFetchParams) => {
    if (params.query && params.query.length > 2) {
      return SearchService.Get(params)
    } else if (!params.query) {
      clearData()
    }
  }

  const { query, results, total, clearData, fetchData, loadMore } = useFetchWithPagination(search, {
    culture: cmsData.culture,
    pageId: cmsData.context,
    perPage: 8,
    currentPage: 1,
  })

  const noResultsTitleReplaced = computed(() => {
    return cmsData.noResultsTitle.replaceAll("{{query}}", query.value)
  })

  const remaining = computed(() => {
    return (total.value - results.value.length)
  })

  const searchText = computed(() => {
    const fallbackString = "{aantal} van {totaal} " + (total.value === 1 ? "resultaat" : "resultaten") +" voor '{zoekterm}'";

    if(!cmsData.resultText) {
      return fallbackString.replaceAll("{aantal}", results.value.length.toString()).replaceAll("{totaal}", total.value.toString()).replaceAll("{zoekterm}", query.value);
    }
    return cmsData.resultText.replaceAll("{aantal}", results.value.length.toString()).replaceAll("{totaal}", total.value.toString()).replaceAll("{zoekterm}", query.value);
  })
</script>

<template>
  <div class="container overview-scoped md:max-w-2.5xl-plus">
    <search-bar
      v-model:query="query"
      :cms-data
      :placeholder="cmsData.searchbarPlaceholder"
      @execute-search="fetchData(true)"
      @clear-query="clearData"
    />
    <p
      v-if="total > 0"
      class="flex flex-col md:flex-row md:justify-between md:items-center general-label-text mb-4 md:mb-6"
      v-text="searchText"
    />
    <div class="no-results flex flex-col md:flex-row md:justify-between md:items-center general-label-text md:mb-6">
      <div
        v-if="query.length > 0 && total === 0"
        class="mb-[104px]"
      >
        <h2
          class="text-xl lg:text-heading-5 mb-4"
          v-text="noResultsTitleReplaced"
        />
        <div
          class="no-results-content"
          v-html="cmsData.noResultsText"
        />
      </div>
    </div>
    <search-item
      v-for="item in results"
      :key="item.id"
      class="mb-6"
      :cms-data="cmsData"
      :item="item"
    />
    <LoadMoreButton
      v-if="remaining > 0"
      class="mb-40 general-label-text"
      :number-of-items="remaining.toString()"
      @load-more="loadMore"
    />
  </div>
</template>
